module.exports = __webpack_public_path__ + "static/media/素炸魚排便當.96b72cf8.jpg";